<style lang="scss">
  @import './user-group-expression.scss';
</style>
<template>
<ul class="user-group-expression-content-item-details-wrap">
  <li
    v-for="item in this.dataItemList"
    :key="item"
    class="user-group-expression-content-item-details-wrap-item">
    <p v-if="typeof expressionInfo[item] === 'object' && expressionInfo[item].length > 0">
      <slot name="itemTitle"></slot>
      <span
        v-for="(value, index) in expressionInfo[item]" 
        :key="index">{{ value }}</span>
    </p>
    <p v-else-if="typeof expressionInfo[item] === 'string'">
      <slot name="itemTitle"></slot><span>{{ expressionInfo[item] }}</span>
    </p>
    <span v-else><slot name="itemTitle"></slot>{{ $t('userGroup.all') }}</span>
  </li>
</ul>
</template>
<script>
  export default {
    name: 'expressionDetails',
    props: {
      expressionInfo: Object,
      itemName: String,
    },
    computed: {
      dataItemList() {
        const array = Object.keys(this.expressionInfo);
        return array.filter(x => x.indexOf(this.itemName) > -1);
      },
    },
  };
</script>
